import React, { createContext, useContext } from 'react';

const PortalScopeContext = createContext(null);

export function PortalScopeProvider({ account, mode, children }) {
  return (
    <PortalScopeContext.Provider value={{ account, mode }}>
      {children}
    </PortalScopeContext.Provider>
  );
}

export function usePortalScope() {
  const ctx = useContext(PortalScopeContext);
  if (!ctx) throw new Error('usePortalScope must be used within <PortalScopeProvider>');
  return ctx;
}
